import React, { useEffect, useState, useCallback , useMemo} from 'react'
import styled from 'styled-components'
import ButtonRow from '../../components/Gamification/ButtonRow'
import FlagStatus from '../../components/nftInfo/FlagStatus'
import useAllowanceAll from '../../hooks/nft/useAllowanceAll'
import useUserStakes from '../../hooks/nft/useUserStakes'
import useUserBids from '../../hooks/nft/useUserBids'
import useUserAsks from '../../hooks/nft/useUserAsks'
import { useActiveWeb3React } from '../../hooks'
import Player from './Player'
import { MARKETTYPE, MARKETMULTITOKEN } from '../../constants/bakery/nft'
import { userGameNftTypeV1V2 } from '../../userType/userGameNftTypeV1V2'
import { NFTTYPE } from '../../constants/bakery/nft'

const pokerCard = "POKERCARD"
const ArtworksCard = styled.div<{ showBorder: boolean, bg?: string }>`
  position: relative;
  display: flex;
  flex-direction: column;
  background-color: ${({bg, theme}) => (bg ? bg : theme.bsBg15)};
  width: 280px;
  min-height: 513px;
  margin-bottom: 25px !important;
  text-decoration: none;
  cursor: pointer;
  &:hover {
    background-color: ${({bg, theme}) => (bg ? bg : theme.bsBg15)};
    box-shadow: 0px 2px 10px rgba(171, 133, 115, 0.16);
  }
  margin-right: 10px;
  margin-left: 10px;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  &:before{
    content: ${({ showBorder }) => (showBorder ? 'url(/images/nft/realcarBorder.png)' : '')};
    position: absolute;
    z-index: 9;
    top: -5px;
    left: -1px;
  }
`
const IconArtwork = styled.div<{ bg?: string }>`
  display: block;
  width: 100%;
  height: 100%;
  background-image: url(${({ bg }) => (bg ? bg : '')});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  position: relative;
  box-sizing: border-box;
`
const CardHead = styled.div<{ bg?: string }>`
  position: relative;
  width: 100%;
  height: 362px;
  overflow: hidden;
  border-radius: 20px 20px 0px 0px;
  background-image: url(${({ bg }) => (bg ? bg : '')});
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  &.${pokerCard}{
    padding: 15px;
  }
`
const CardFoot = styled.div<{ pad?: string }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: ${({ pad }) => pad ? pad : '0'};
  overflow: hidden;
  padding: 16px;
`

const Title = styled.div<{ mar?: string,color?: string }>`
  width: 100%;
  font-size: 16px;
  line-height: 22px;
  height: 44px;
  overflow-y: hidden;
  font-family: Baloo Da;
  font-weight: bold;
  font-size: 22px;
  color: ${({color, theme}) => (color ? color : theme.bsText7)};
`

export function Artworks({
    artwork,
    artworklength,
    type,
    nftType,
    isMyArtwork,
    showBorder,
    isBlindbox,
    isCanTransfer,
    isCanStake,
    tokenName,
    solt
}: {
    artwork: any,
    artworklength: number,
    type: string,
    nftType?: any,
    isMyArtwork?: boolean,
    showBorder: boolean,
    isBlindbox?: boolean,
    isCanTransfer?: boolean,
    isCanStake?: boolean,
    tokenName?: string,
    solt?: any
}) {
    const level = useMemo(() => {
      return artwork.level
    }, [artwork])
    const { account } = useActiveWeb3React()

    // 获取我的竞价
    const getBids = useUserBids(nftType)
    const emptyBids: any[] = []
    const [ids, setIds] = useState(emptyBids)
    const getIds = useCallback(async() => {
        const bids = await getBids()
        if (bids.length) {
        const bidsId = bids.map((d: any) => {
            return d[0]
        })
        setIds(bidsId)
        }
    }, [getBids])


    useEffect(() => {
      if (account) {
        getIds()
      }
    }, [getBids, getIds, account, artwork])

    // 获取我的stake
    const getStakes = useUserStakes(type)
    const getStakesV2 = useUserStakes(type + "_V2")
  
    const emptyStakes: any[] = []
    const [stakesIds, setStakesIds] = useState(emptyStakes)
    // 存v2的
    const [stakesIds_v2, setStakesIds_V2] = useState(emptyStakes)
    const getStakesIds = useCallback(async () => {
        const stakes = await getStakes()
        let stakesV2:any = []
        if([
          NFTTYPE.DOGGIES,
          NFTTYPE.BARKING,
          NFTTYPE.EQUIPMENT,
          NFTTYPE.BAKEMUSKMIXER,
          NFTTYPE.CAR,
          NFTTYPE.COMBO,
          NFTTYPE.SOCCER,
          NFTTYPE.POKER,
        ].includes(type)){
          stakesV2 = await getStakesV2()
        }
        if (stakes.length || stakesV2.length) {
          const stakesId = stakes.map((d: any) => {
              return d
          })
          const stakesIdV2 = stakesV2.map((d: any) => {
            return d
          })
          setStakesIds([...stakesId,...stakesIdV2])
          setStakesIds_V2(stakesIdV2)
        } else {
          setStakesIds([])
          setStakesIds_V2([])
        }
    }, [getStakes, getStakesV2])

    // 获取我的另一个版本的stake
    let gameType2:any = userGameNftTypeV1V2(type)
    const getStakes2 = useUserStakes(gameType2)
    const getStakes2_2 = useUserStakes(gameType2 + "_V2")
    const [stakesIds2, setStakesIds2] = useState(emptyStakes)
    const getStakesIds2 = useCallback(async () => {
      const stakes = await getStakes2()
      let stakesV2:any = []
      if([
        NFTTYPE.DOGGIES,
        NFTTYPE.BARKING,
        NFTTYPE.EQUIPMENT,
        NFTTYPE.BAKEMUSKMIXER,
        NFTTYPE.CAR,
        NFTTYPE.COMBO,
        NFTTYPE.SOCCER,
        NFTTYPE.POKER,
      ].includes(gameType2)){
        stakesV2 = await getStakes2_2()
      }
      if (stakes.length || stakesV2.length) {
        const stakesId = stakes.map((d: any) => {
            return d
        })
        const stakesIdV2 = stakesV2.map((d: any) => {
          return d
        })
        setStakesIds2([...stakesId,...stakesIdV2])
      } else {
        setStakesIds2([])
      }
    }, [getStakes2, getStakes2_2])
  
    useEffect(() => {
      if(gameType2){
        getStakesIds2()
      }
      getStakesIds()
    }, [artwork, getStakesIds, gameType2, getStakesIds2])

  // 获取我的挂单
  const getMyAsks = useUserAsks(nftType)
  const emptyAsks: any[] = []

  const [myAksIds, setMyAskIds] = useState(emptyAsks)
  const getAskIds = useCallback(async() => {
    const myAsks = await getMyAsks()
    if (myAsks.length) {
      const myAsksId = myAsks.map((d: any) => {
        return d[0]
      })
      setMyAskIds(myAsksId)
    }
  }, [getMyAsks])

  useEffect(() => {
    getAskIds()
  }, [artwork, getAskIds])
  // 是否允许抵押
  const allowanceStake = useAllowanceAll({type: type})
    return (
        <ArtworksCard className='fourItem' showBorder={showBorder} bg={level ==='v3' || isMyArtwork  ? '' : '#DEDEDE'}>
            <FlagStatus isMyArtwork={isMyArtwork}  artwork={artwork} ids={ids} />
            {
              artwork.fileType === 3 ? (
                <Player 
                  player={artwork} 
                  isMyArtwork={isMyArtwork} 
                ></Player>
              ) : (
                <CardHead 
                  bg={[MARKETTYPE.CARNFT].includes(nftType) ? '/images/nft/carbgblack.pn' : ''}
                  className={[
                    [MARKETMULTITOKEN.RACAMULTITOKEN].includes(nftType) ? pokerCard : ''
                  ].join(' ')
                  }
                >
                {
                    artworklength > 10 ? (
                        <IconArtwork 
                          bg={artwork.minImage || artwork.image}
                        />
                    ) : (
                        <IconArtwork 
                          bg={artwork.image} 
                        />
                    )
                }
                </CardHead>
              )
            }
            <CardFoot>
              <Title color={level ==='v3'  || isMyArtwork ? '' : '#776D63'}>
                  {artwork.titleName}
                  {' # ' + artwork.tokenId}
              </Title>
              {
                  solt ? solt : null
              }
              <ButtonRow 
                ids={ids}
                myAksIds={myAksIds}
                artwork={artwork}
                type={type}
                nftType={nftType}
                isMyArtwork={isMyArtwork}
                tokenName={tokenName}
                isBlindbox={isBlindbox}
                stakesIds={stakesIds}
                stakesIds2={stakesIds2}
                stakesIds_v2={stakesIds_v2}
                isCanTransfer={isCanTransfer}
                isCanStake={isCanStake}
                allowanceStake={allowanceStake}
              ></ButtonRow>
            </CardFoot>
        </ArtworksCard>
    )
}
